import cn from "classnames"
import { Formik } from "formik"
import React, { Component } from 'react'
import PageContents from '../components/pageContents'
import SEO from "../components/seo"
import NewLayout from '../layout/newLayout'
import { sendContact } from "../services/contact"
import styles from '../styles/scss/pages/industrialForm.module.scss'
import {
	TextInput,
	Textarea,
	Select,
	ErrorSummary,
	FormStatus,
	SubmitButton,
	RequiredNote,
	bind,
	summaryErrors,
	phoneError,
	zipError,
	isValidEmail,
	formStyles as f,
} from '../components/form'

export default class Index extends Component {

	state = {
		submitted: false,
		submitError: false,
		selectedIndustry: null,
	};

	industries = [{
		value: 'food-beverage',
		text: 'Food & Beverage'
	}, {
		value: 'oil-gas-chemical',
		text: 'Oil / Gas / Chemical'
	}, {
		value: 'mining-aggregate',
		text: 'Mining / Aggregate'
	}, {
		value: 'forest-paper',
		text: 'Forest / Paper'
	}, {
		value: 'power-utilities',
		text: 'Power & Utilities'
	}, {
		value: 'pharmaceutical',
		text: 'Pharmaceutical'
	}, {
		value: 'government',
		text: 'Government'
	}, {
		value: 'transportation-vehicles',
		text: 'Transportation / Vehicles'
	}, {
		value: 'warehouse-logistics',
		text: 'Warehouse & Logistics'
	}, {
		value: 'metal-metal-fabrication',
		text: 'Metal / Metal Fabrication'
	}, {
		value: 'commercial-construction',
		text: 'Commercial/Construction'
	}, {
		value: 'other',
		text: 'OTHER'
	}]

	render() {
		const pg = this.props.pageContext.page
		const attached = pg.attachments.filter((att) => {
			return att.slug === 'thank-you-contact'
		})
		var thankyou = null
		if (attached.length > 0) {
			thankyou = attached[0]
		} else {
			throw new Error("thank-you-contact is not attached")
		}

		return (
			<NewLayout>
				{pg.seo.title && <h1 style={{ display: 'none' }}>{pg.seo.title}</h1>}
				<SEO page={pg} />
				<div className='d-flex flex-column flex-fill'>
					<div className={styles.container}>
						<>
							<div className={cn(styles.formItems, "row")}>
								<div className={styles.formContainer}>
									{
										this.state.submitted ?
										<PageContents content={thankyou.content} />
										:
										<>
											<PageContents content={pg.content} />
											<h3 className={styles.infoTitle}>
												personal information
											</h3>
											<Formik
												initialValues={{
													first_name: "",
													last_name: "",
													job_title: "",
													company: "",
													phone: "",
													email: "",
													address: "",
													zip_code: "",
													industry: "",
													question: "",
												}}
												validate={values => {
													var errors = []
													if (values.first_name === "") {
														errors.push({ field: "first_name", message: "First Name is required" })
													}
													if (values.last_name === "") {
														errors.push({ field: "last_name", message: "Last Name is required" })
													}
													if (values.email === "") {
														errors.push({ field: "email", message: "Email is required" })
													} else if (!isValidEmail(values.email)) {
														errors.push({ field: "email", message: "Invalid email address" })
													}
													const phoneMsg = phoneError(values.phone)
													if (phoneMsg) errors.push({ field: "phone", message: phoneMsg })
													const zipMsg = zipError(values.zip_code)
													if (zipMsg) errors.push({ field: "zip_code", message: zipMsg })
													return errors
												}}
												onSubmit={(values, { setSubmitting }) => {
													this.setState({ submitError: false })
													sendContact(values, 'technical-specialist').then(() => {
														setSubmitting(false)
														this.setState({ submitted: true })
													}).catch((err) => {
														console.log('ERROR!')
														console.log(err)
														setSubmitting(false)
														this.setState({ submitError: true })
													})
												}}
											>
												{(props) => (
													<form className={f.form} onSubmit={props.handleSubmit} noValidate>
														<RequiredNote />
														<ErrorSummary errors={summaryErrors(props)} submitCount={props.submitCount} />
														<FormStatus status={this.state.submitError ? "error" : null} />
														<div className={f.row}>
															<TextInput label="First Name" required autoComplete="given-name" {...bind(props, "first_name")} />
															<TextInput label="Last Name" required autoComplete="family-name" {...bind(props, "last_name")} />
														</div>
														<div className={f.row}>
															<TextInput label="Job Title" autoComplete="organization-title" {...bind(props, "job_title")} />
															<TextInput label="Company" autoComplete="organization" {...bind(props, "company")} />
														</div>
														<div className={f.row}>
															<TextInput label="Phone" type="tel" mask="phone" autoComplete="tel-national" {...bind(props, "phone")} />
															<TextInput label="Email" type="email" required autoComplete="email" {...bind(props, "email")} />
														</div>
														<div className={f.row}>
															<TextInput label="Address" autoComplete="street-address" {...bind(props, "address")} />
															<TextInput label="Zip Code" autoComplete="postal-code" {...bind(props, "zip_code")} />
														</div>
														<div className={f.row}>
															<Select label="Industry" placeholder="Select An Industry" options={this.industries} {...bind(props, "industry")} />
														</div>
														<Textarea label="What is your question for our Technical Specialist?" {...bind(props, "question")} />
														<div className={f.actions}>
															<SubmitButton busy={props.isSubmitting}>Submit</SubmitButton>
														</div>
													</form>
												)}
											</Formik>
										</>
									}
								</div>
							</div>
						</>
					</div>
				</div>
			</NewLayout>
		);
	}
}